<template>
  <div>
    <div class="flex justify-end pb-5">
      <Switch
        v-model="showOuterCircle"
        :label="$t('pages.campaigns.statisticPointsList.map.showOuterCircle')"
        class="inline-block pr-10"
      />
    </div>
    <FullScreenMap v-slot="{ fullScreen }">
      <Box :aspect="0.4" class="map-container mb-15" :class="{ '!h-screen !w-screen': fullScreen }">
        <ShowLocationMap
          :points="points"
          :show-info="true"
          :hide-inner-circle="!showOuterCircle"
        >
          <template #info="{ point }">
            <h6>{{ point.name }}</h6>
            {{
              $t('pages.campaigns.statisticPointsList.map.infoWindowText', {
                stops: point.statistics.stops,
                time: formatTimeDurationFromSeconds(point.statistics.time),
              })
            }}
          </template>
        </ShowLocationMap>
      </Box>
    </FullScreenMap>
  </div>
</template>

<script lang="ts" setup>
import Box from '@components/utils/Box.vue';
import { computed, ref } from 'vue';
import ShowLocationMap from '@utils/maps/ShowLocationMap.vue';
import FullScreenMap from '@utils/FullScreenMap.vue';
import Switch from '@utils/inputs/Switch.vue';
import { formatTimeDurationFromSeconds } from '@/utils/helpers';
import type { StatisticPoint } from '@/entities/Entities';

interface Props {
  points?: StatisticPoint[];
}

const props = defineProps<Props>();
const points = computed(() => props.points?.map((point) => ({
  id: point.id,
  gisLocation: point.gisLocation,
  radius: point.radius,
  value: (typeof point.radius !== 'number' || point.radius === 0) ? 0 : (point.statistics?.time ?? 0) / point.radius,
  name: point.name,
  statistics: point.statistics,
})));

const showOuterCircle = ref(true);
</script>
